export default __webpack_public_path__ + "static/media/warning--gate-left--g1.060d16fa.png";